/*

MIT License

Copyright (c) 2017 Igor Kroitor

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/

//-----------------------------------------------------------------------------


/* eslint-disable */

import { Exchange, BaseExchange }  from './src/base/Exchange.js'
import PredictionExchange from './src/base/PredictionExchange.js'
import { Precise }   from './src/base/Precise.js'
import * as functions from './src/base/functions.js'
import * as errors   from './src/base/errors.js'
import type { Int, int, Str, Strings, Num, Bool, IndexType, OrderSide, OrderType, MarketType, SubType, Dict, NullableDict, List, NullableList, Fee, OHLCV, OHLCVC, implicitReturnType, Market, Currency, Dictionary, NestedDictionary, MinMax, FeeInterface, TradingFeeInterface, MarketInterface, Precision, PredictionEvent, PredictionOutcome, PredictionMarket, PredictionSettlement, PredictionFees, PredictionOrder, PredictionTrade, PredictionPosition, PredictionTicker, PredictionOrderBook, PredictionTickers, PredictionTradingFee, PredictionOpenInterest, PredictionOrderRequest, fetchEventsParams, Trade, Order, OrderBook, Ticker, Transaction, Tickers, CurrencyInterface, Balance, BalanceAccount, Account, PartialBalances, Balances, DepositAddress, WithdrawalResponse, FundingRate, FundingRates, Position, BorrowInterest, LeverageTier, LedgerEntry, DepositWithdrawFeeNetwork, DepositWithdrawFee, TransferEntry, CrossBorrowRate, IsolatedBorrowRate, FundingRateHistory, OpenInterest, Liquidation, OrderRequest, CancellationRequest, FundingHistory, MarketMarginModes, MarginMode, Greeks, Conversion, Option, LastPrice, Leverage, MarginModification, Leverages, LastPrices, Currencies, TradingFees, MarginModes, OptionChain, IsolatedBorrowRates, CrossBorrowRates, LeverageTiers, LongShortRatio, OrderBooks, OpenInterests, ConstructorArgs, ADL } from './src/base/types.js'
import {BaseError, ExchangeError, AuthenticationError, PermissionDenied, AccountNotEnabled, AccountSuspended, ArgumentsRequired, BadRequest, BadSymbol, OperationRejected, NoChange, MarginModeAlreadySet, MarketClosed, ManualInteractionNeeded, RestrictedLocation, InsufficientFunds, InvalidAddress, AddressPending, InvalidOrder, OrderNotFound, OrderNotCached, OrderImmediatelyFillable, OrderNotFillable, DuplicateOrderId, ContractUnavailable, NotSupported, InvalidProxySettings, ExchangeClosedByUser, OperationFailed, NetworkError, DDoSProtection, RateLimitExceeded, ExchangeNotAvailable, OnMaintenance, InvalidNonce, ChecksumError, RequestTimeout, BadResponse, NullResponse, CancelPending, UnsubscribeError}  from './src/base/errors.js'


//-----------------------------------------------------------------------------
// this is updated by vss.js when building

const version = '4.5.70';

//-----------------------------------------------------------------------------

import alpaca from  './src/alpaca.js'
import apex from  './src/apex.js'
import aster from  './src/aster.js'
import backpack from  './src/backpack.js'
import bequant from  './src/bequant.js'
import bigone from  './src/bigone.js'
import binance from  './src/binance.js'
import binancecoinm from  './src/binancecoinm.js'
import binanceus from  './src/binanceus.js'
import binanceusdm from  './src/binanceusdm.js'
import bingx from  './src/bingx.js'
import bit2c from  './src/bit2c.js'
import bitbank from  './src/bitbank.js'
import bitbns from  './src/bitbns.js'
import bitfinex from  './src/bitfinex.js'
import bitflyer from  './src/bitflyer.js'
import bitget from  './src/bitget.js'
import bithumb from  './src/bithumb.js'
import bitmart from  './src/bitmart.js'
import bitmex from  './src/bitmex.js'
import bitopro from  './src/bitopro.js'
import bitrue from  './src/bitrue.js'
import bitso from  './src/bitso.js'
import bitstamp from  './src/bitstamp.js'
import bitteam from  './src/bitteam.js'
import bittrade from  './src/bittrade.js'
import bitvavo from  './src/bitvavo.js'
import blockchaincom from  './src/blockchaincom.js'
import blofin from  './src/blofin.js'
import btcbox from  './src/btcbox.js'
import btcmarkets from  './src/btcmarkets.js'
import btcturk from  './src/btcturk.js'
import bullish from  './src/bullish.js'
import bybit from  './src/bybit.js'
import bybiteu from  './src/bybiteu.js'
import bydfi from  './src/bydfi.js'
import cex from  './src/cex.js'
import coinbase from  './src/coinbase.js'
import coinbaseexchange from  './src/coinbaseexchange.js'
import coinbaseinternational from  './src/coinbaseinternational.js'
import coincheck from  './src/coincheck.js'
import coinex from  './src/coinex.js'
import coinmate from  './src/coinmate.js'
import coinone from  './src/coinone.js'
import coinsph from  './src/coinsph.js'
import coinspot from  './src/coinspot.js'
import cryptocom from  './src/cryptocom.js'
import cryptomus from  './src/cryptomus.js'
import deepcoin from  './src/deepcoin.js'
import delta from  './src/delta.js'
import deribit from  './src/deribit.js'
import derive from  './src/derive.js'
import digifinex from  './src/digifinex.js'
import dydx from  './src/dydx.js'
import exmo from  './src/exmo.js'
import extended from  './src/extended.js'
import fmfwio from  './src/fmfwio.js'
import foxbit from  './src/foxbit.js'
import gate from  './src/gate.js'
import gateeu from  './src/gateeu.js'
import gemini from  './src/gemini.js'
import grvt from  './src/grvt.js'
import hashkey from  './src/hashkey.js'
import hibachi from  './src/hibachi.js'
import hitbtc from  './src/hitbtc.js'
import hollaex from  './src/hollaex.js'
import htx from  './src/htx.js'
import hyperliquid from  './src/hyperliquid.js'
import independentreserve from  './src/independentreserve.js'
import indodax from  './src/indodax.js'
import kraken from  './src/kraken.js'
import krakenfutures from  './src/krakenfutures.js'
import kucoin from  './src/kucoin.js'
import kucoineu from  './src/kucoineu.js'
import kucoinfutures from  './src/kucoinfutures.js'
import latoken from  './src/latoken.js'
import lbank from  './src/lbank.js'
import lighter from  './src/lighter.js'
import luno from  './src/luno.js'
import mercado from  './src/mercado.js'
import mexc from  './src/mexc.js'
import modetrade from  './src/modetrade.js'
import mudrex from  './src/mudrex.js'
import myokx from  './src/myokx.js'
import nado from  './src/nado.js'
import ndax from  './src/ndax.js'
import okx from  './src/okx.js'
import okxus from  './src/okxus.js'
import onetrading from  './src/onetrading.js'
import p2b from  './src/p2b.js'
import pacifica from  './src/pacifica.js'
import paradex from  './src/paradex.js'
import paymium from  './src/paymium.js'
import phemex from  './src/phemex.js'
import poloniex from  './src/poloniex.js'
import tokocrypto from  './src/tokocrypto.js'
import toobit from  './src/toobit.js'
import upbit from  './src/upbit.js'
import weex from  './src/weex.js'
import whitebit from  './src/whitebit.js'
import woo from  './src/woo.js'
import woofipro from  './src/woofipro.js'
import xt from  './src/xt.js'
import zaif from  './src/zaif.js'
import zebpay from  './src/zebpay.js'


// pro exchanges
import alpacaPro from  './src/pro/alpaca.js'
import apexPro from  './src/pro/apex.js'
import asterPro from  './src/pro/aster.js'
import backpackPro from  './src/pro/backpack.js'
import bequantPro from  './src/pro/bequant.js'
import binancePro from  './src/pro/binance.js'
import binancecoinmPro from  './src/pro/binancecoinm.js'
import binanceusPro from  './src/pro/binanceus.js'
import binanceusdmPro from  './src/pro/binanceusdm.js'
import bingxPro from  './src/pro/bingx.js'
import bitfinexPro from  './src/pro/bitfinex.js'
import bitgetPro from  './src/pro/bitget.js'
import bithumbPro from  './src/pro/bithumb.js'
import bitmartPro from  './src/pro/bitmart.js'
import bitmexPro from  './src/pro/bitmex.js'
import bitoproPro from  './src/pro/bitopro.js'
import bitruePro from  './src/pro/bitrue.js'
import bitstampPro from  './src/pro/bitstamp.js'
import bittradePro from  './src/pro/bittrade.js'
import bitvavoPro from  './src/pro/bitvavo.js'
import blockchaincomPro from  './src/pro/blockchaincom.js'
import blofinPro from  './src/pro/blofin.js'
import bullishPro from  './src/pro/bullish.js'
import bybitPro from  './src/pro/bybit.js'
import bybiteuPro from  './src/pro/bybiteu.js'
import bydfiPro from  './src/pro/bydfi.js'
import cexPro from  './src/pro/cex.js'
import coinbasePro from  './src/pro/coinbase.js'
import coinbaseexchangePro from  './src/pro/coinbaseexchange.js'
import coinbaseinternationalPro from  './src/pro/coinbaseinternational.js'
import coincheckPro from  './src/pro/coincheck.js'
import coinexPro from  './src/pro/coinex.js'
import coinonePro from  './src/pro/coinone.js'
import cryptocomPro from  './src/pro/cryptocom.js'
import deepcoinPro from  './src/pro/deepcoin.js'
import deribitPro from  './src/pro/deribit.js'
import derivePro from  './src/pro/derive.js'
import dydxPro from  './src/pro/dydx.js'
import exmoPro from  './src/pro/exmo.js'
import extendedPro from  './src/pro/extended.js'
import gatePro from  './src/pro/gate.js'
import gateeuPro from  './src/pro/gateeu.js'
import geminiPro from  './src/pro/gemini.js'
import grvtPro from  './src/pro/grvt.js'
import hashkeyPro from  './src/pro/hashkey.js'
import hitbtcPro from  './src/pro/hitbtc.js'
import hollaexPro from  './src/pro/hollaex.js'
import htxPro from  './src/pro/htx.js'
import hyperliquidPro from  './src/pro/hyperliquid.js'
import independentreservePro from  './src/pro/independentreserve.js'
import krakenPro from  './src/pro/kraken.js'
import krakenfuturesPro from  './src/pro/krakenfutures.js'
import kucoinPro from  './src/pro/kucoin.js'
import kucoineuPro from  './src/pro/kucoineu.js'
import kucoinfuturesPro from  './src/pro/kucoinfutures.js'
import lbankPro from  './src/pro/lbank.js'
import lighterPro from  './src/pro/lighter.js'
import lunoPro from  './src/pro/luno.js'
import mexcPro from  './src/pro/mexc.js'
import modetradePro from  './src/pro/modetrade.js'
import mudrexPro from  './src/pro/mudrex.js'
import myokxPro from  './src/pro/myokx.js'
import nadoPro from  './src/pro/nado.js'
import ndaxPro from  './src/pro/ndax.js'
import okxPro from  './src/pro/okx.js'
import okxusPro from  './src/pro/okxus.js'
import onetradingPro from  './src/pro/onetrading.js'
import p2bPro from  './src/pro/p2b.js'
import pacificaPro from  './src/pro/pacifica.js'
import paradexPro from  './src/pro/paradex.js'
import phemexPro from  './src/pro/phemex.js'
import poloniexPro from  './src/pro/poloniex.js'
import toobitPro from  './src/pro/toobit.js'
import upbitPro from  './src/pro/upbit.js'
import weexPro from  './src/pro/weex.js'
import whitebitPro from  './src/pro/whitebit.js'
import wooPro from  './src/pro/woo.js'
import woofiproPro from  './src/pro/woofipro.js'
import xtPro from  './src/pro/xt.js'

import hyperliquidPrediction from  './src/prediction/hyperliquid.js'
import kalshiPrediction from  './src/prediction/kalshi.js'
import limitlessPrediction from  './src/prediction/limitless.js'
import myriadPrediction from  './src/prediction/myriad.js'
import polymarketPrediction from  './src/prediction/polymarket.js'

const exchanges = {
    'alpaca':                 alpaca,
    'apex':                   apex,
    'aster':                  aster,
    'backpack':               backpack,
    'bequant':                bequant,
    'bigone':                 bigone,
    'binance':                binance,
    'binancecoinm':           binancecoinm,
    'binanceus':              binanceus,
    'binanceusdm':            binanceusdm,
    'bingx':                  bingx,
    'bit2c':                  bit2c,
    'bitbank':                bitbank,
    'bitbns':                 bitbns,
    'bitfinex':               bitfinex,
    'bitflyer':               bitflyer,
    'bitget':                 bitget,
    'bithumb':                bithumb,
    'bitmart':                bitmart,
    'bitmex':                 bitmex,
    'bitopro':                bitopro,
    'bitrue':                 bitrue,
    'bitso':                  bitso,
    'bitstamp':               bitstamp,
    'bitteam':                bitteam,
    'bittrade':               bittrade,
    'bitvavo':                bitvavo,
    'blockchaincom':          blockchaincom,
    'blofin':                 blofin,
    'btcbox':                 btcbox,
    'btcmarkets':             btcmarkets,
    'btcturk':                btcturk,
    'bullish':                bullish,
    'bybit':                  bybit,
    'bybiteu':                bybiteu,
    'bydfi':                  bydfi,
    'cex':                    cex,
    'coinbase':               coinbase,
    'coinbaseexchange':       coinbaseexchange,
    'coinbaseinternational':  coinbaseinternational,
    'coincheck':              coincheck,
    'coinex':                 coinex,
    'coinmate':               coinmate,
    'coinone':                coinone,
    'coinsph':                coinsph,
    'coinspot':               coinspot,
    'cryptocom':              cryptocom,
    'cryptomus':              cryptomus,
    'deepcoin':               deepcoin,
    'delta':                  delta,
    'deribit':                deribit,
    'derive':                 derive,
    'digifinex':              digifinex,
    'dydx':                   dydx,
    'exmo':                   exmo,
    'extended':               extended,
    'fmfwio':                 fmfwio,
    'foxbit':                 foxbit,
    'gate':                   gate,
    'gateeu':                 gateeu,
    'gemini':                 gemini,
    'grvt':                   grvt,
    'hashkey':                hashkey,
    'hibachi':                hibachi,
    'hitbtc':                 hitbtc,
    'hollaex':                hollaex,
    'htx':                    htx,
    'hyperliquid':            hyperliquid,
    'independentreserve':     independentreserve,
    'indodax':                indodax,
    'kraken':                 kraken,
    'krakenfutures':          krakenfutures,
    'kucoin':                 kucoin,
    'kucoineu':               kucoineu,
    'kucoinfutures':          kucoinfutures,
    'latoken':                latoken,
    'lbank':                  lbank,
    'lighter':                lighter,
    'luno':                   luno,
    'mercado':                mercado,
    'mexc':                   mexc,
    'modetrade':              modetrade,
    'mudrex':                 mudrex,
    'myokx':                  myokx,
    'nado':                   nado,
    'ndax':                   ndax,
    'okx':                    okx,
    'okxus':                  okxus,
    'onetrading':             onetrading,
    'p2b':                    p2b,
    'pacifica':               pacifica,
    'paradex':                paradex,
    'paymium':                paymium,
    'phemex':                 phemex,
    'poloniex':               poloniex,
    'tokocrypto':             tokocrypto,
    'toobit':                 toobit,
    'upbit':                  upbit,
    'weex':                   weex,
    'whitebit':               whitebit,
    'woo':                    woo,
    'woofipro':               woofipro,
    'xt':                     xt,
    'zaif':                   zaif,
    'zebpay':                 zebpay,
}

const pro = {
    'alpaca':                 alpacaPro,
    'apex':                   apexPro,
    'aster':                  asterPro,
    'backpack':               backpackPro,
    'bequant':                bequantPro,
    'binance':                binancePro,
    'binancecoinm':           binancecoinmPro,
    'binanceus':              binanceusPro,
    'binanceusdm':            binanceusdmPro,
    'bingx':                  bingxPro,
    'bitfinex':               bitfinexPro,
    'bitget':                 bitgetPro,
    'bithumb':                bithumbPro,
    'bitmart':                bitmartPro,
    'bitmex':                 bitmexPro,
    'bitopro':                bitoproPro,
    'bitrue':                 bitruePro,
    'bitstamp':               bitstampPro,
    'bittrade':               bittradePro,
    'bitvavo':                bitvavoPro,
    'blockchaincom':          blockchaincomPro,
    'blofin':                 blofinPro,
    'bullish':                bullishPro,
    'bybit':                  bybitPro,
    'bybiteu':                bybiteuPro,
    'bydfi':                  bydfiPro,
    'cex':                    cexPro,
    'coinbase':               coinbasePro,
    'coinbaseexchange':       coinbaseexchangePro,
    'coinbaseinternational':  coinbaseinternationalPro,
    'coincheck':              coincheckPro,
    'coinex':                 coinexPro,
    'coinone':                coinonePro,
    'cryptocom':              cryptocomPro,
    'deepcoin':               deepcoinPro,
    'deribit':                deribitPro,
    'derive':                 derivePro,
    'dydx':                   dydxPro,
    'exmo':                   exmoPro,
    'extended':               extendedPro,
    'gate':                   gatePro,
    'gateeu':                 gateeuPro,
    'gemini':                 geminiPro,
    'grvt':                   grvtPro,
    'hashkey':                hashkeyPro,
    'hitbtc':                 hitbtcPro,
    'hollaex':                hollaexPro,
    'htx':                    htxPro,
    'hyperliquid':            hyperliquidPro,
    'independentreserve':     independentreservePro,
    'kraken':                 krakenPro,
    'krakenfutures':          krakenfuturesPro,
    'kucoin':                 kucoinPro,
    'kucoineu':               kucoineuPro,
    'kucoinfutures':          kucoinfuturesPro,
    'lbank':                  lbankPro,
    'lighter':                lighterPro,
    'luno':                   lunoPro,
    'mexc':                   mexcPro,
    'modetrade':              modetradePro,
    'mudrex':                 mudrexPro,
    'myokx':                  myokxPro,
    'nado':                   nadoPro,
    'ndax':                   ndaxPro,
    'okx':                    okxPro,
    'okxus':                  okxusPro,
    'onetrading':             onetradingPro,
    'p2b':                    p2bPro,
    'pacifica':               pacificaPro,
    'paradex':                paradexPro,
    'phemex':                 phemexPro,
    'poloniex':               poloniexPro,
    'toobit':                 toobitPro,
    'upbit':                  upbitPro,
    'weex':                   weexPro,
    'whitebit':               whitebitPro,
    'woo':                    wooPro,
    'woofipro':               woofiproPro,
    'xt':                     xtPro,
}

for (const exchange in pro) {
    // const ccxtExchange = exchanges[exchange]
    // const baseExchange = Object.getPrototypeOf (ccxtExchange)
    // if (baseExchange.name === 'Exchange') {
    //     Object.setPrototypeOf (ccxtExchange, wsExchange)
    //     Object.setPrototypeOf (ccxtExchange.prototype, wsExchange.prototype)
    // }
}

(pro as any).exchanges = Object.keys (pro)
pro['Exchange'] = Exchange // now the same for rest and ts
//-----------------------------------------------------------------------------

const prediction = {
    'hyperliquid':            hyperliquidPrediction,
    'kalshi':                 kalshiPrediction,
    'limitless':              limitlessPrediction,
    'myriad':                 myriadPrediction,
    'polymarket':             polymarketPrediction,
};

(prediction as any).exchanges = Object.keys (prediction)
// the namespace's `Exchange` alias must be the prediction base, not the crypto Exchange —
// prediction instances are `instanceof PredictionExchange`, NOT `instanceof Exchange` (siblings)
prediction['Exchange'] = PredictionExchange
//-----------------------------------------------------------------------------

const ccxt = Object.assign ({ version, Exchange, BaseExchange, PredictionExchange, Precise, 'exchanges': Object.keys (exchanges), 'pro': pro, 'prediction': prediction}, exchanges, functions, errors)

export {
    version,
    Exchange,
    BaseExchange,
    PredictionExchange,
    exchanges,
    pro,
    prediction,
    Precise,
    functions,
    errors,
    BaseError,
    ExchangeError,
    AuthenticationError,
    PermissionDenied,
    AccountNotEnabled,
    AccountSuspended,
    ArgumentsRequired,
    BadRequest,
    BadSymbol,
    OperationRejected,
    NoChange,
    MarginModeAlreadySet,
    MarketClosed,
    ManualInteractionNeeded,
    RestrictedLocation,
    InsufficientFunds,
    InvalidAddress,
    AddressPending,
    InvalidOrder,
    OrderNotFound,
    OrderNotCached,
    OrderImmediatelyFillable,
    OrderNotFillable,
    DuplicateOrderId,
    ContractUnavailable,
    NotSupported,
    InvalidProxySettings,
    ExchangeClosedByUser,
    OperationFailed,
    NetworkError,
    DDoSProtection,
    RateLimitExceeded,
    ExchangeNotAvailable,
    OnMaintenance,
    InvalidNonce,
    ChecksumError,
    RequestTimeout,
    BadResponse,
    NullResponse,
    CancelPending,
    UnsubscribeError,
    Int,
    int,
    Str,
    Strings,
    Num,
    Bool,
    IndexType,
    OrderSide,
    OrderType,
    MarketType,
    SubType,
    Dict,
    NullableDict,
    List,
    NullableList,
    Fee,
    OHLCV,
    OHLCVC,
    implicitReturnType,
    Market,
    Currency,
    ConstructorArgs,
    Dictionary,
    NestedDictionary,
    MinMax,
    FeeInterface,
    TradingFeeInterface,
    MarketMarginModes,
    Precision,
    MarketInterface,
    PredictionFees,
    PredictionEvent,
    PredictionMarket,
    PredictionOutcome,
    PredictionOrder,
    PredictionTrade,
    PredictionPosition,
    PredictionTicker,
    PredictionOrderBook,
    PredictionTickers,
    PredictionTradingFee,
    PredictionOpenInterest,
    PredictionSettlement,
    fetchEventsParams,
    Trade,
    Order,
    OrderBook,
    OrderBooks,
    Ticker,
    Transaction,
    Tickers,
    CurrencyInterface,
    Balance,
    BalanceAccount,
    Account,
    PartialBalances,
    Balances,
    DepositAddress,
    WithdrawalResponse,
    FundingRate,
    FundingRates,
    Position,
    BorrowInterest,
    LeverageTier,
    LedgerEntry,
    DepositWithdrawFeeNetwork,
    DepositWithdrawFee,
    TransferEntry,
    CrossBorrowRate,
    IsolatedBorrowRate,
    FundingRateHistory,
    OpenInterest,
    OpenInterests,
    Liquidation,
    OrderRequest,
    PredictionOrderRequest,
    CancellationRequest,
    FundingHistory,
    MarginMode,
    Greeks,
    Conversion,
    Option,
    LastPrice,
    Leverage,
    LongShortRatio,
    ADL,
    MarginModification,
    Leverages,
    LastPrices,
    Currencies,
    TradingFees,
    MarginModes,
    OptionChain,
    IsolatedBorrowRates,
    CrossBorrowRates,
    LeverageTiers,
    alpaca,
    apex,
    aster,
    backpack,
    bequant,
    bigone,
    binance,
    binancecoinm,
    binanceus,
    binanceusdm,
    bingx,
    bit2c,
    bitbank,
    bitbns,
    bitfinex,
    bitflyer,
    bitget,
    bithumb,
    bitmart,
    bitmex,
    bitopro,
    bitrue,
    bitso,
    bitstamp,
    bitteam,
    bittrade,
    bitvavo,
    blockchaincom,
    blofin,
    btcbox,
    btcmarkets,
    btcturk,
    bullish,
    bybit,
    bybiteu,
    bydfi,
    cex,
    coinbase,
    coinbaseexchange,
    coinbaseinternational,
    coincheck,
    coinex,
    coinmate,
    coinone,
    coinsph,
    coinspot,
    cryptocom,
    cryptomus,
    deepcoin,
    delta,
    deribit,
    derive,
    digifinex,
    dydx,
    exmo,
    extended,
    fmfwio,
    foxbit,
    gate,
    gateeu,
    gemini,
    grvt,
    hashkey,
    hibachi,
    hitbtc,
    hollaex,
    htx,
    hyperliquid,
    independentreserve,
    indodax,
    kraken,
    krakenfutures,
    kucoin,
    kucoineu,
    kucoinfutures,
    latoken,
    lbank,
    lighter,
    luno,
    mercado,
    mexc,
    modetrade,
    mudrex,
    myokx,
    nado,
    ndax,
    okx,
    okxus,
    onetrading,
    p2b,
    pacifica,
    paradex,
    paymium,
    phemex,
    poloniex,
    tokocrypto,
    toobit,
    upbit,
    weex,
    whitebit,
    woo,
    woofipro,
    xt,
    zaif,
    zebpay,    
}

export default ccxt;

//-----------------------------------------------------------------------------
